module.exports = __webpack_public_path__ + "images/nav/logo-white.png";